"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getLine = exports.getLine = function getLine(point1, point2) {
    return {
        start: point1,
        end: point2
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/line.js
// module id = 2278
// module chunks = 0